<h1 mat-dialog-title>Delete Document</h1>
<div mat-dialog-content>
  <p>Are you sure you want to delete {{data.id}}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <button mat-raised-button color="primary" (click)="deleteDocument()" cdkFocusInitial>DELETE</button>
</div>
